import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import { mapRoomResponseToRoom } from 'app/hooks/data/core/admin/rooms/mapping/room';
import { useRoomCategories } from 'app/hooks/data/rooms/useRoomCategories';
import type { RoomResponse } from 'app/typings/core/admin/rooms/room';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useGetRoom(id?: string | number) {
  const { data: roomCategories } = useRoomCategories();
  const roomId = typeof id === 'string' ? id : id?.toString();

  const response = useQuery({
    queryKey: [CORE_QUERY_KEYS.room, { id: roomId }],
    queryFn: roomId
      ? () =>
          apiRequest({
            path: ENDPOINTS.getRoom,
            params: { id: roomId },
          }) as Promise<RoomResponse>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!roomId,
  });

  return {
    ...response,
    data: mapRoomResponseToRoom(response.data, roomCategories),
  };
}
